import { cn } from '@/lib/utils';

/**
 * Renders a workflow-status color dot with a self-contrasting border.
 *
 * The border color is derived entirely in CSS: `oklch(from <fill> calc(1 - l) 0 0)`
 * inverts the fill's lightness (neutral gray scale), so a white fill gets a black
 * border and a black fill gets a white border — visible on any background/theme.
 * On browsers too old for relative color syntax the inline `borderColor` is dropped
 * and the `border-text-gray dark:border-white` classes provide a theme-adaptive fallback.
 */
export const StatusColorSwatch = ({ color, className }: { color: string; className?: string }) => (
  <div
    className={cn('icon-3 shrink-0 rounded-full border-2 border-text-gray dark:border-white', className)}
    style={{ backgroundColor: color, borderColor: `oklch(from ${color} calc(1 - l) 0 0)` }}
  />
);
